import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { CONTACT_CARDS_COMBINED_WIDTH } from "../consts";
import { ListOfArticles } from "./ListOfArticles";
export var HelpArticlesCard = function HelpArticlesCard(_ref) {
  var articles = _ref.articles,
    viewHasInstantAnswer = _ref.viewHasInstantAnswer,
    visibleWhen = _ref.visibleWhen,
    onClickOnArticle = _ref.onClickOnArticle,
    loadTimingRef = _ref.loadTimingRef;
  if (!visibleWhen) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, viewHasInstantAnswer ? /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }) : null, /*#__PURE__*/React.createElement(Wrapper, {
    ref: loadTimingRef
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "AQWd6w",
    defaultMessage: [{
      "type": 0,
      "value": "Artigos relacionados"
    }]
  })), /*#__PURE__*/React.createElement(ListOfArticles, {
    articles: articles,
    viewHasInstantAnswer: viewHasInstantAnswer,
    onClickOnArticle: onClickOnArticle
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }));
};
var Wrapper = styled(Column).withConfig({
  displayName: "HelpArticlesCard__Wrapper"
})(["max-width:", ";width:100%;", "{width:", ";}"], CONTACT_CARDS_COMBINED_WIDTH, responsiveMediaQueries.desktopAndAbove, CONTACT_CARDS_COMBINED_WIDTH);